import "../../App.css"
import { Sidebar, LikedVideoContainer } from "../components"

export const Liked = () => {
    return (
        <div className="main-container">
            <Sidebar />
            <LikedVideoContainer />
        </div>

    )
}
